// This file configures the initialization of Sentry on the browser. The config you add here will be
// used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = "/sentry-monitoring-tunnel";globalThis["SENTRY_RELEASE"] = undefined;globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:not-found*\",\"regex\":\"^/(.+)$\",\"paramNames\":[\"not-found\"]},{\"path\":\"/patents/:document_number\",\"regex\":\"^/patents/([^/]+)$\",\"paramNames\":[\"document_number\"]},{\"path\":\"/search/engine/:search_id\",\"regex\":\"^/search/engine/([^/]+)$\",\"paramNames\":[\"search_id\"]},{\"path\":\"/search/partner/:id\",\"regex\":\"^/search/partner/([^/]+)$\",\"paramNames\":[\"id\"]},{\"path\":\"/search/partner/:id/edit\",\"regex\":\"^/search/partner/([^/]+)/edit$\",\"paramNames\":[\"id\"]}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/data-coverage\"},{\"path\":\"/login\"},{\"path\":\"/profile/account\"},{\"path\":\"/profile/billing\"},{\"path\":\"/profile/sso\"},{\"path\":\"/profile/users\"},{\"path\":\"/register\"},{\"path\":\"/reset-password\"},{\"path\":\"/saml\"},{\"path\":\"/search/partner\"},{\"path\":\"/search/partner/freedom-to-operate\"},{\"path\":\"/search/partner/new\"},{\"path\":\"/search/partner/patentability\"},{\"path\":\"/search/partner/validity\"}]}";import {
  captureConsoleIntegration,
  init,
  replayIntegration,
} from '@sentry/nextjs'
import { stringify } from 'flatted'

init({
  dsn: 'https://bd8d5e09c380461b93be12e924c18bd7@o1032814.ingest.us.sentry.io/6133207',

  tracesSampler: (samplingContext) => {
    if (samplingContext.name.includes('health')) {
      return 0
    }

    return 1
  },
  integrations: [
    replayIntegration({
      maskAllText: false,
      mask: ['#descriptionInput', '#inputPatentDescription'],
    }),
    captureConsoleIntegration({ levels: ['error'] }),
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
  environment: process.env.NEXT_PUBLIC_ENV,
  ignoreErrors: ['No authentication present'],
  beforeSend(event, _hint) {
    const jsonError = stringify(event).toLowerCase()
    if (jsonError.includes('no authentication present')) {
      return null
    }

    return event
  },
  maxValueLength: 2000,
  normalizeMaxBreadth: 20,
  normalizeDepth: 10,
  ignoreTransactions: [/^middleware$/],
})
